// removed by extract-text-webpack-plugin
module.exports = {"gameTabsContainer":"_3R_r6kgsSzC6sNDainWYnc","gameTabs":"_3f_4ItfrDNJy7WfBHqU7RH","scroll":"_3svGWopDxOl0dd5AoWG-_U","leftArrow":"_2K8Q0wMA2OjKlY6MZ4tlRK","rightArrow":"_2P_Ccx4plO8bE3i8c5LQ00","leftArrowIcon":"_1mt-XjBBKx6lHJqtk6MOUa","rightArrowIcon":"fN4cvn5jyNnHCcS5rnrxR"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/simplified/sharedComponents/css/gameTabs.css
// module id = 1029
// module chunks = 0